var $db1f19116eb8b089$exports = {};
$db1f19116eb8b089$exports = {
    "(optional)": `(\u{9078}\u{586B})`,
    "(required)": `(\u{5FC5}\u{586B})`
};


export {$db1f19116eb8b089$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
